export default __webpack_public_path__ + "static/GavulaXMas--2025-587fbe8ee94f360a8fa25a00fb317142.pdf";